import { useSuspenseQuery } from '@apollo/client';
import {
  FETCH_CHAPTER_BY_UUID,
  FetchChapterByUuidQuery,
  FetchChapterByUuidQueryVariables,
  HomePage,
} from '@edwin-group/cj-graphql';
import { useNavigate } from 'react-router-dom';
import { usePickUpWhereYouLeftOff } from '../../hooks/usePickUpWhereYouLeftOff';

export const PickUpWhereYouLeftOff = ({ page }: { page: HomePage | null }) => {
  const navigate = useNavigate();
  const { lastChapterOpened } = usePickUpWhereYouLeftOff();

  const { data } = useSuspenseQuery<FetchChapterByUuidQuery, FetchChapterByUuidQueryVariables>(FETCH_CHAPTER_BY_UUID, {
    variables: {
      uuid: lastChapterOpened?.chapterUUID,
      documentId: lastChapterOpened?.missionDocumentId || '',
    },
  });

  if (!lastChapterOpened) {
    return null;
  }

  const onClick = () => {
    navigate(`/mission/${data?.mission?.slug}/chapter/${data?.mission?.chapters?.[0]?.title}`);
  };

  return (
    <div className="flex h-full flex-col items-center gap-sh-15 rounded-2xl bg-[#D380D6] p-5 text-center">
      <h2 className=" text-center font-aTypeStencil text-sh-24-22 uppercase text-[#A8F4E8]">
        {page?.cardsSection?.pickUpWhereYouLeftOff?.title}
      </h2>
      <p className="font-cadiz text-sh-xxs text-white">
        {page?.cardsSection?.pickUpWhereYouLeftOff?.prefix} <br></br>
        <span className="font-bold ">{data?.mission?.chapters?.[0]?.title}</span>
      </p>

      <button
        type="button"
        className="font-cadiz text-sh-xxs font-bold text-[#A8F4E8] hover:opacity-50"
        onClick={onClick}>
        {page?.cardsSection?.pickUpWhereYouLeftOff?.btnText}
      </button>
    </div>
  );
};
